import { render, staticRenderFns } from "./manageTypes.vue?vue&type=template&id=546a105a&"
import script from "./manageTypes.vue?vue&type=script&lang=js&"
export * from "./manageTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports